"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCheckUserRightsResponse = void 0;

var _BooleanAsNumber = require("../../../types/BooleanAsNumber");

var _modelBuilders = require("../../../utils/model-builders");

var _genericAsResultHeader = require("../../../utils/generic-as-result-header");

/*
  Sample XML Response:
    <CheckUserRightsResponse xmlns="http://www.aperio.com/webservices/">
      <CheckUserRightsResult>
          <ASResult>0</ASResult>
          <ASMessage>
          </ASMessage>
          <ASDetails>
          </ASDetails>
      </CheckUserRightsResult>
      <r1>6</r1>
      <Token>f7cd15b30ddbb7022d7270dd90f0da69bd915fa88eb0af6b01dc7cbc8f02e518</Token>
      <TokenExpirationTime>2018-03-06T14:37:02.4648437-08:00</TokenExpirationTime>
      <SaveAnnotation>1</SaveAnnotation>
      <SaveMacro>1</SaveMacro>
      <RunAnalysis>1</RunAnalysis>
      <ViewLabel>1</ViewLabel>
    </CheckUserRightsResponse>
*/
var createCheckUserRightsResponse = function createCheckUserRightsResponse(raw) {
  return (0, _modelBuilders.parseModel)(raw, {
    result: {
      path: 'CheckUserRightsResult[0]',
      model: _genericAsResultHeader.genericAsResultHeader
    },
    response: function response(raw) {
      return {
        saveAnnotation: (0, _BooleanAsNumber.BooleanAsNumber)(raw.SaveAnnotation),
        saveMacro: (0, _BooleanAsNumber.BooleanAsNumber)(raw.SaveMacro),
        runAnalysis: (0, _BooleanAsNumber.BooleanAsNumber)(raw.RunAnalysis),
        viewLabel: (0, _BooleanAsNumber.BooleanAsNumber)(raw.ViewLabel)
      };
    }
  });
};

exports.createCheckUserRightsResponse = createCheckUserRightsResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/user/response-parsers/check-user-rights-response.js
// module id = 239
// module chunks = 0